export class MpaRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MpaOperationType",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "MpaEntityType",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MpaRequestStatus",
            "format": ""
        },
        {
            "name": "requestMethod",
            "baseName": "requestMethod",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestPath",
            "baseName": "requestPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestBody",
            "baseName": "requestBody",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterId",
            "baseName": "requesterId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterName",
            "baseName": "requesterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "policyDetails",
            "baseName": "policyDetails",
            "type": "Array<MpaRequestPolicyDetail>",
            "format": ""
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "approvalExpirationTime",
            "baseName": "approvalExpirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "executionExpirationTime",
            "baseName": "executionExpirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resolvedTime",
            "baseName": "resolvedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return MpaRequest.attributeTypeMap;
    }
    constructor() {
    }
}
